import { create } from 'zustand';

// One message at a time: a second `show` overwrites the first, which is what
// DraftTemplatesTab relies on when it rewrites progress counts in a loop.
interface LoadingMessageState {
  isVisible: boolean;
  message: string;
  show: (message: string) => void;
  hide: () => void;
}

export const useLoadingMessageStore = create<LoadingMessageState>((set) => ({
  isVisible: false,
  message: '',

  show: (message) => set({ isVisible: true, message }),
  hide: () => set({ isVisible: false, message: '' }),
}));
